import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "name", "postalCode", "address", "directions", "venueId"]

  fill() {
    const selectEl = this.selectTarget
    const venueId = selectEl.value
    const venues = JSON.parse(selectEl.dataset.venues || "[]")
    const venue = venues.find(v => String(v.id) === venueId)

    if (venue) {
      if (this.hasNameTarget) this.nameTarget.value = venue.name || ""
      if (this.hasPostalCodeTarget) this.postalCodeTarget.value = venue.postal_code || ""
      if (this.hasAddressTarget) this.addressTarget.value = venue.address || ""
      if (this.hasDirectionsTarget) this.directionsTarget.value = venue.directions || ""
      if (this.hasVenueIdTarget) this.venueIdTarget.value = venueId
    } else {
      if (this.hasNameTarget) this.nameTarget.value = ""
      if (this.hasPostalCodeTarget) this.postalCodeTarget.value = ""
      if (this.hasAddressTarget) this.addressTarget.value = ""
      if (this.hasDirectionsTarget) this.directionsTarget.value = ""
      if (this.hasVenueIdTarget) this.venueIdTarget.value = ""
    }

    // プレビュー更新のため input イベントを発火
    const targets = []
    if (this.hasNameTarget) targets.push(this.nameTarget)
    if (this.hasPostalCodeTarget) targets.push(this.postalCodeTarget)
    if (this.hasAddressTarget) targets.push(this.addressTarget)
    if (this.hasDirectionsTarget) targets.push(this.directionsTarget)
    targets.forEach(target => {
      target.dispatchEvent(new Event("input", { bubbles: true }))
    })
  }
}
